export function targetStep0() {
    return window.location.pathname == `/clients/payroll_rules_groups` ? `.m-table-list` : '.none'
}
export function targetStep1() {
    return window.location.pathname == `/clients/payroll_rules_groups` ? `td.PayrollRulesGroupTableRow__allownce--zT7re` : '.none'
}
export function targetStep2(param) {
    if (param) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.id}/allowances` ?
            `a[href="/clients/payroll_rules_groups/${param.id}/unit_prices"]` : '.none'
    }
    return '.none'
}
export function targetStep3(param) {
    if (param) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.id}/unit_prices` ?
            `table.m-table-list` : '.none'
    }
    return '.none'
}
export function targetStep4(param) {
    if (param) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.id}/unit_prices` ?
            `.ClientUnitPriceTableRow__icons--12ut0 span:nth-child(1)` : '.none'
    }
    return '.none'
}
export function targetStep5(param) {
    if (param && param.clientPayrollRulesGroupId && param.id) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.clientPayrollRulesGroupId}/unit_prices/${param.id}/edit` ?
            `.Form__boxMain--1CHRX` : '.none'
    }
    return '.none'
}
export function targetStep6(param) {
    if (param && param.clientPayrollRulesGroupId && param.id) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.clientPayrollRulesGroupId}/unit_prices/${param.id}/edit` ?
            `#formula` : '.none'
    }
    return '.none'
}

export function targetStep7(param) {
    if (param && param.clientPayrollRulesGroupId && param.id) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.clientPayrollRulesGroupId}/unit_prices/${param.id}/edit` ?
            `#rounding-section` : '.none'
    }
    return '.none'
}

export function targetStep8(param) {
    if (param && param.clientPayrollRulesGroupId && param.id) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.clientPayrollRulesGroupId}/unit_prices/${param.id}/edit` ?
            `.u-ta-c` : '.none'
    }
    return '.none'
}
export function targetStep9(param) {
    if (param) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.id}/unit_prices` ?
            `a[href='/clients/payroll_rules_groups/${param.id}/allowances']` : '.none'
    }
    return '.none'
}
export function targetStep10(param) {
    if (param) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.id}/allowances` ?
            `table.m-table-list` : '.none'
    }
    return '.none'
}
export function targetStep11(param) {
    if (param) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.id}/allowances` ?
            `.AllowanceRow__icons--26Tal` : '.none'
    }
    return '.none'
}
export function targetStep12(param) {
    if (param && param.id && param.clientPayrollRulesGroupId) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.clientPayrollRulesGroupId}/allowances/${param.id}/edit` ?
            `.TargetSettings__child_indent--2OpB7` : '.none'
    }
    return '.none'
}
export function targetStep13(param) {
    if (param && param.id && param.clientPayrollRulesGroupId) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.clientPayrollRulesGroupId}/allowances/${param.id}/edit` ?
            `.Form__boxWrap--3FgDf:last-child .Form__icnTextarea--2r7W_` : '.none'
    }
    return '.none'
}
export function targetStep14(param) {
    if (param && param.id && param.clientPayrollRulesGroupId) {
        return window.location.pathname == `/clients/payroll_rules_groups/${param.clientPayrollRulesGroupId}/allowances/${param.id}/edit` ?
            `.u-ta-c` : '.none'
    }
    return '.none'
}